import lang from '@/lang'
import {
  awaitableConfirmationModal,
  AwaitableConfirmationModalIcons,
} from '@/modules/base/components/modal/_helpers/awaitableConfirmationModal'
import { RefreshAnalysisCandidate } from '@/modules/document/utils/refresh-analysis-eligibility'

export interface RefreshAnalysisDocument extends RefreshAnalysisCandidate {
  id: string | number
}

// FLAG:useDocuAi — one confirmation and one transport for every „Erneut analysieren" entry
// (drawer menu, first review, embedded review, expense, and other revenue). Keeping the
// wording here prevents one host from accidentally promising that a fresh run overwrites the
// currently reviewed values; it deliberately does not — adoption remains explicit.
export const confirmAndRefreshInvoiceAnalysis = async(document: RefreshAnalysisDocument): Promise<boolean> => {
  const confirmed = await awaitableConfirmationModal({
    isOpen: true,
    title: lang.documents.refreshAnalysis.title,
    description: document?.documentInvoiceDetails?.reviewStatus
      ? lang.documents.refreshAnalysis.description
      : lang.documents.refreshAnalysis.descriptionUnreviewed,
    confirmLabel: lang.documents.refreshAnalysis.confirm,
    cancelLabel: lang.documents.refreshAnalysis.cancel,
    confirmIcon: AwaitableConfirmationModalIcons.checkIcon,
  })
  if (!confirmed) { return false }

  // Keep the review/detail button light at module-load time. DocumentAnalysisService owns the
  // legacy analysis stack (Redux drawer, scan modals, subscriptions); loading all of that merely
  // because a review renders this button also drags unrelated ESM-only controls into isolated
  // review tests. The service is needed only after the user confirmed the action.
  const { DocumentAnalysisService } = await import('@/modules/document/services/documentAnalysis')
  return DocumentAnalysisService.refreshAnalysis(document)
}
